import { Controller } from "@hotwired/stimulus"

// Narrows a long list of choice chips (e.g. 40 languages) as the user types.
// Selected chips always stay visible. Accent-insensitive: "yoruba" finds "Yorùbá".
const normalize = (text) => text.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().trim()

export default class extends Controller {
  static targets = ["input", "chip"]

  filter() {
    const query = normalize(this.inputTarget.value)

    this.chipTargets.forEach((chip) => {
      const selected = chip.querySelector("input")?.checked
      chip.hidden = query !== "" && !selected && !normalize(chip.dataset.label || "").includes(query)
    })
  }

  // Enter in the filter box must not submit the whole form
  ignoreEnter(event) {
    if (event.key === "Enter") event.preventDefault()
  }
}
